// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13.5 18V14H14V18H13.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M15.4142 1H3V23H21V20H19V14H18.5V20H16.5V12H19.25C20.2165 12 21 12.7835 21 13.75V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5ZM7 12V20H5V12H7ZM9.5 14V18H11V20H9.25C8.2835 20 7.5 19.2165 7.5 18.25V13.75C7.5 12.7835 8.2835 12 9.25 12H11V14H9.5ZM13.25 12H14.25C15.2165 12 16 12.7835 16 13.75V18.25C16 19.2165 15.2165 20 14.25 20H13.25C12.2835 20 11.5 19.2165 11.5 18.25V13.75C11.5 12.7835 12.2835 12 13.25 12Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-icon-filled')
export default class FileIconFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-icon-filled',
    }
  }
}
